import { PurposeRecord } from '../types/purpose.type';
import { EPurpose } from '../enums/purpose.enum';

export const PURPOSE_OPTIONS: PurposeRecord = {
  [EPurpose.None]: {
    id: EPurpose.None,
    value: null,
    viewValue: '',
  },
  [EPurpose.OwnStay]: {
    id: EPurpose.OwnStay,
    value: EPurpose.OwnStay,
    viewValue: 'Own Stay',
  },
  [EPurpose.Investment]: {
    id: EPurpose.Investment,
    value: EPurpose.Investment,
    viewValue: 'Investment',
  },
};
